function swymCallbackFn(swat) {
  function swymAttachEvents() {
    swat.initializeActionButtons("div.fancybox-container");
  }
  document.addEventListener("quickview:loaded", function (e) {
    swymAttachEvents();
  });
}

// Initialize global variables
let themeGlobalSwat = "";
let globalListArray = [];
let currentVariantId = "";

// Initialize Swym callbacks
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(function (swat) {
  themeGlobalSwat = swat;
  updateGlobalListArray();
  persistWishlistButtonsState();
});

const overlay = document.body.querySelector(".cart-black-overlay-wl");

overlay.addEventListener("click", function (event) {
  fadeOut();
  const wishlistVariant = document.body.querySelector(".wishlist-variant");
  if (
    wishlistVariant &&
    wishlistVariant.classList.contains("wishlist-variant")
  ) {
    wishlistVariant.querySelectorAll(".variant-options").forEach((x, i) => {
      x.classList.remove("selected");
    });
    fadeOut();
    document.documentElement.classList.remove("no-scroll");
    wishlistVariant.querySelector(".wishlist-variant__image img").src = "";
    wishlistVariant.querySelector(".product-title").innerHTML = "NN";
    wishlistVariant.querySelector(".options-wrapper").innerHTML = "";
    wishlistVariant.querySelector(".existing-wishlist-select").innerHTML = "";
    wishlistVariant.querySelector(".wishlist-all-images").innerHTML = "";
    wishlistVariant.classList.remove("show");
  }
});

function fadeIn() {
  overlay.style.display = "block"; // Make it visible
  setTimeout(() => {
    overlay.classList.add("show"); // Start the transition
  }, 10); // Slight delay to allow the transition to apply
}

function fadeOut() {
  overlay.style.display = "none"; // Hide after the transition
  setTimeout(() => {
    overlay.classList.remove("show"); // Start fading out
  });
}

const overlayLoading = document.body.querySelector(".wishlist-loader");

function loadingFadeIn() {
  setTimeout(() => {
    overlayLoading.classList.add("show"); // Start the transition
  }, 1); // Slight delay to allow the transition to apply
}

function loadingFadeOut() {
  setTimeout(() => {
    overlayLoading.classList.remove("show"); // Start fading out
  }, 2000);
}

// Check if themeGlobalSwat is null or empty and invoke SwymCallbacks if it is
async function checkAndInvokeSwymCallbacks() {
  if (!themeGlobalSwat) {
    await window.SwymCallbacks.push(function (swat) {
      themeGlobalSwat = swat;
      updateGlobalListArray();
      persistWishlistButtonsState();
    });
  }
}

// Check if a variant is present in the lists
function isVariantPresentInLists() {
  globalListArray.forEach((list) => {
    const listId = list.lid;
    const listInput = document.querySelector(
      `.existing-wishlist-select .option[data-productvalue="${listId}"] button`
    );

    const variantIsPresent =
      listInput &&
      list.listcontents.some(
        (variant) => variant.epi.toString() === currentVariantId
      );

    listInput?.setAttribute("variantexistsinlist", variantIsPresent);
    listInput.innerHTML = variantIsPresent ? "Remove" : "Add";
    if (listInput && variantIsPresent) {
      listInput?.classList.add("button-wishlish-remove-product");
      listInput?.classList.remove("button-wishlish-add-product");
    } else {
      listInput?.classList.remove("button-wishlish-remove-product");
      listInput?.classList.add("button-wishlish-add-product");
    }
  });
}

function persistWishlistButtonsState() {
  return new Promise((resolve, reject) => {
    let onSuccess = function (lists) {
      globalListArray = lists;
      let buttons = document.querySelectorAll("button.button-wishlish-click");
      let productIds = [];

      let ctr = 0;
      lists.forEach((list) => {
        list.listcontents.forEach((product) => {
          let productId = product.empi;
          productIds.push(productId);
        });
        ctr++;
        if (ctr === lists.length) {
          buttons.forEach((button) => {
            let productId = button.getAttribute("data-product-id");
            if (productIds.includes(parseInt(productId))) {
              SwymUtils.addClass(button, "swym-added");
            } else {
              SwymUtils.removeClass(button, "swym-added");
            }
          });
        }
      });

      resolve();
    };

    let onError = function (error) {
      console.error("Error while fetching all Lists", error);
      reject(error);
    };

    themeGlobalSwat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError,
    });
  });
}

// Update the global list array
function updateGlobalListArray() {
  themeGlobalSwat.fetchLists({
    callbackFn: function (lists) {
      globalListArray = lists;
      isVariantPresentInLists();
      persistWishlistButtonsState();
    },
    errorFn: function (error) {
      console.log("Error while fetching all Lists", error);
    },
  });
}

// Handle click events on the document body
document.body.addEventListener("click", function (event) {
  // Handle variant option selection
  if (
    event.target.classList.contains("variant-options") ||
    (event.target.tagName === "SPAN" &&
      event.target.closest(".variant-options"))
  ) {
    const button = event.target.closest(".variant-options");

    button.parentNode.querySelectorAll(".variant-options").forEach((x, i) => {
      x.classList.remove("selected");
    });

    button.classList.add("selected");
    currentVariantId = button.getAttribute("data-variant-id");
    isVariantPresentInLists();
  }

  // Handle adding a product to the wishlist
  if (event.target.classList.contains("button-wishlish-add-product")) {
    let topParent = event.target
      .closest(".wishlist-variant__right-top")
      .querySelector(".options-wrapper .selected");

    let lid = event.target.parentNode.getAttribute("data-productvalue");

    if (!topParent) {
      Toastify({
        text: "Please select a product variant.",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
      return;
    }

    var product = {
      epi: topParent.getAttribute("data-variant-id"),
      empi: topParent.getAttribute("data-product-id"),
      du: topParent.getAttribute("data-product-url"),
    };

    let onSuccess = async function (addedListItem) {
      updateGlobalListArray();
      persistWishlistButtonsState();
      Toastify({
        text: "Product added to wishlist",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
    };

    let onError = function (error) {
      console.log("Error while adding the Product to the List", error);
    };

    themeGlobalSwat.addToList(lid, product, onSuccess, onError);
  }

  // Handle removing a product from the wishlist
  if (event.target.classList.contains("button-wishlish-remove-product")) {
    let topParent = event.target
      .closest(".wishlist-variant__right-top")
      .querySelector(".options-wrapper .selected");

    let lid = event.target.parentNode.getAttribute("data-productvalue");

    if (!topParent) {
      Toastify({
        text: "Please select a product variant.",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
      return;
    }

    var product = {
      epi: topParent.getAttribute("data-variant-id"),
      empi: topParent.getAttribute("data-product-id"),
      du: topParent.getAttribute("data-product-url"),
    };

    let onSuccess = async function (addedListItem) {
      updateGlobalListArray();
      persistWishlistButtonsState();
      Toastify({
        text: "Product removed from wishlist",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
    };

    let onError = function (error) {
      console.log("Error while removing the Product from the List", error);
    };

    themeGlobalSwat.deleteFromList(lid, product, onSuccess, onError);
  }
});

// Success callback for fetching lists
let onSuccessGetList = function (lists, select) {
  select.innerHTML = "";
  lists.forEach((x, i) => {
    let option = `<div role="button" class="option" data-productvalue="${x?.lid}">${x?.lname}
            <button class="button-option button-wishlish-add-product">Add</button>   
            </div>`;
    select.insertAdjacentHTML("beforeend", option);
  });

  return lists;
};

// Error callback for fetching lists
let onErrorGetList = function (error) {
  console.log("Error while fetching all Lists", error);
};

// Fetch all existing wishlist items
function getAllExistingWishlistItems(select) {
  return themeGlobalSwat.fetchLists({
    callbackFn: (lists) => onSuccessGetList(lists, select),
    errorFn: onErrorGetList,
  });
}

// Success callback for creating a wishlist
let onSuccessCreateWishlist = function (
  newList,
  input,
  select,
  successMessage
) {
  getAllExistingWishlistItems(select);
  updateGlobalListArray();
  input.value = "";
  if (successMessage) {
    Toastify({
      text: "Wishlist added successfully",
      duration: 3000,
      close: true,
      style: {
        background: "#000",
      },
    }).showToast();
  }
};

// Error callback for creating a wishlist
let onErrorCreateWishlist = function (error) {
  console.log("Error while creating a List", error);
};

// Create a new wishlist
function createWishlist(
  input,
  name,
  select,
  noExistingWishlist = false,
  successMessage = true
) {
  if (noExistingWishlist) {
    if (globalListArray.length > 0) {
      return;
    }
  }
  let listConfig = {
    lname: name,
  };
  themeGlobalSwat.createList(
    listConfig,
    (lists) => onSuccessCreateWishlist(lists, input, select, successMessage),
    onErrorCreateWishlist
  );
}

// Handle click events on existing wishlist buttons
const addNewWishlistButton = document.querySelectorAll(
  ".existing-wishlist-button-add"
);

function isListNameAlreadyExists(name) {
  return globalListArray.some((list) => list.lname === name);
}

addNewWishlistButton.forEach((button) => {
  button.addEventListener("click", async function () {
    let input = button.parentNode.querySelector("input.new-wishlist-name");
    let inputName = input.value;

    if(!(inputName.length > 2 && inputName.length < 50)) {
      Toastify({
        text: "Please enter a wishlist name between 3 and 50 characters.",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
      return;
    }

    let isExists = await isListNameAlreadyExists(inputName);

    if (!inputName || isExists) {
      Toastify({
        text: isExists
          ? "Please choose a different wishlist name."
          : "Please enter a wishlist name.",
        duration: 3000,
        close: true,
        style: {
          background: "#000",
        },
      }).showToast();
      return;
    }

    createWishlist(
      input,
      inputName,
      button.parentNode.parentNode.querySelector("div.existing-wishlist-select")
    );
  });
});

// Handle click events on existing wishlist buttons
const addNewWishlistButtonCancel = document.querySelectorAll(
  ".existing-wishlist-button-cancel"
);

addNewWishlistButtonCancel.forEach((button) => {
  button.addEventListener("click", function (e) {
    button.parentElement.classList.add("hide");
    button.parentElement.classList.remove("show");
    const enableButton = button
      .closest(".wishlist-variant__right-top")
      .querySelector(".existing-wishlist-button-enable");
    enableButton.classList.remove("hide");
  });
});

// Handle click events on existing wishlist buttons
const addNewWishlistEnable = document.querySelectorAll(
  ".existing-wishlist-button-enable"
);

addNewWishlistEnable.forEach((button) => {
  button.addEventListener("click", function (e) {
    button.parentElement
      .querySelector(".existing-wishlist-select-add-form")
      .classList.add("show");
    button.parentElement
      .querySelector(".existing-wishlist-select-add-form")
      .classList.remove("hide");
    e.target.classList.add("hide");
  });
});

// Handle click events on wishlist close buttons
const wishlistCloseButtons = document.querySelectorAll(
  ".wishlist-variant__close"
);

wishlistCloseButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const wishlistVariant = button.closest(".wishlist-variant");
    if (
      wishlistVariant &&
      wishlistVariant.classList.contains("wishlist-variant")
    ) {
      wishlistVariant.querySelectorAll(".variant-options").forEach((x, i) => {
        x.classList.remove("selected");
      });
      fadeOut();
      document.documentElement.classList.remove("no-scroll");
      wishlistVariant.querySelector(".wishlist-variant__image img").src = "";
      wishlistVariant.querySelector(".product-title").innerHTML = "NN";
      wishlistVariant.querySelector(".options-wrapper").innerHTML = "";
      wishlistVariant.querySelector(".existing-wishlist-select").innerHTML = "";
      wishlistVariant.querySelector(".wishlist-all-images").innerHTML = "";
      wishlistVariant.classList.remove("show");
    }
  });
});

async function getProductById(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}.js`);
    const product = await response.json();
    return product;
  } catch (error) {
    console.error("Error fetching product:", error);
  }
}

async function touchOrClickEvent(event) {
  if (event.target.classList.contains("button-wishlish-click")) {
    loadingFadeIn();
    if (globalListArray.length < 1) {
      createWishlist(
        document.querySelector(
          ".existing-wishlist-select-add-form input.new-wishlist-name"
        ),
        "My Wishlist",
        document.querySelector(".existing-wishlist-select"),
        true,
        false
      );
    }

    let wishlistDom = document.querySelector(".wishlist-variant");
    let productHandle = event.target.getAttribute("data-product-handle");
    let product = await getProductById(productHandle);
    wishlistDom.querySelector(".wishlist-variant__image img").src =
      product?.featured_image;
    wishlistDom.querySelector(".product-title").innerHTML = product?.title;
    wishlistDom.querySelector(".options-wrapper").innerHTML = "";
    wishlistDom.querySelector(".existing-wishlist-select").innerHTML = "";
    wishlistDom.querySelector(".wishlist-all-images").innerHTML = "";
    product?.options.forEach((option) => {
      if (option?.values.length > 1) {
        option?.values.forEach((value, index) => {
          let button = document.createElement("button");
          button.setAttribute("data-product-id", product?.id);
          button.setAttribute("data-variant-id", product?.variants[index].id);
          button.setAttribute("data-product-url", shopUrl + product?.url);
          button.classList.add("variant-options");
          button.innerHTML = value;
          wishlistDom.querySelector(".options-wrapper").appendChild(button);
        });
      }
    });

    product?.images.forEach((image) => {
      let li = document.createElement("li");
      let img = document.createElement("img");
      img.src = image;
      li.classList.add("wishlist-li-image");
      li.appendChild(img);
      li.addEventListener("click", function () {
        wishlistDom.querySelector(".wishlist-variant__image img").src = image;
      });
      wishlistDom.querySelector(".wishlist-all-images").appendChild(li);
    });
    getAllExistingWishlistItems(
      wishlistDom.querySelector(".existing-wishlist-select")
    );

    fadeIn();
    document.documentElement.classList.add("no-scroll");
    wishlistDom.classList.toggle("show");
    loadingFadeOut();
  }
}

function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

function detectDeviceType() {
  if (!isTouchDevice()) {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone/.test(userAgent)) {
    return true;
  } else if (
    /ipad/.test(userAgent) ||
    (navigator.maxTouchPoints > 1 && /macintosh/.test(userAgent))
  ) {
    return true;
  } else if (/android/.test(userAgent)) {
    return true;
  } else if (window.innerWidth >= 768 && window.innerWidth <= 1024) {
    return true;
  } else {
    return false;
  }
}

document.body.addEventListener("touchstart", function (event) {
  if (detectDeviceType()) {
    checkAndInvokeSwymCallbacks();
    touchOrClickEvent(event);
  }
});

document.body.addEventListener("click", function (event) {
  if (!detectDeviceType()) {
    checkAndInvokeSwymCallbacks();
    touchOrClickEvent(event);
  }
});
